<template>
    <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="position-relative">
                        <img src="@/assets/images/page-img/profile-bg1.jpg" alt="profile-bg" class="rounded img-fluid">
                    </div>
                </div>
            </div>
    </div>
    <div class="container containertop">
        <div class="row">
            <div class="col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="text-center">
                        <img class="img-fluid rounded-circle avatar-50" src="@/assets/images/user/07.jpg" alt="profile-img">
                        <h6>John Ramsey</h6>
                        <a href="#">@john_ram</a>
                        <p>Multidisciplinary photographer focused on travel and nature content</p>
                        </div>
                        <div class="d-flex justify-content-evenly">
                        <small class="text-primary">Tweets</small>
                        <small class="text-primary">Follower</small>
                        <small class="text-primary">Follow</small>
                        </div>
                        <div class="d-flex justify-content-evenly">
                        <h4 class="mb-0">847</h4>
                        <h4 class="mb-0">4.2k</h4>
                        <h4 class="mb-0">524</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3 col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                                </svg>
                                <div>Activity</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-primary">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                </svg>
                                <div>Moment</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-lg-6 mt-1">
                        <div class="card">
                            <div class="card-body">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-primary" >
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                <div>Friends</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-lg-6 mt-1">
                        <div class="card">
                            <div class="card-body">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-primary">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <div>Edit</div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-body">
                        <ul class="nav tab-nav-pane nav-tabs  mb-0">
                        <li class="pb-0 mb-0 nav-item"><a data-bs-toggle="tab" data-bs-target="#Tweets" class="font-weight-bold text-uppercase ms-3 active" href="#Tweets">Tweets</a></li>
                        <li class="pb-0 mb-0 nav-item"><a data-bs-toggle="tab" data-bs-target="#TweetsRetweets" class="font-weight-bold text-uppercase ms-3" href="#TweetsRetweets">Tweets & Retweets</a></li>
                        <li class="pb-0 mb-0 nav-item"><a data-bs-toggle="tab" data-bs-target="#Media" class="font-weight-bold text-uppercase ms-3" href="#Media">Media</a></li>
                        <li class="pb-0 mb-0 nav-item"><a data-bs-toggle="tab" data-bs-target="#Likes" class="font-weight-bold text-uppercase ms-3" href="#Likes">Likes</a></li>
                        </ul>
                        <div class="tab-pane fade show active" id="Tweets" role="tabpanel">
                            <div class="mt-2 borderbox1">
                                <div class="user-img me-2">
                                    <img src="@/assets/images/user/1.jpg" alt="userimg" class="avatar-40 rounded-circle">
                                </div>
                                <div class="borderbox border">
                                    <small>LEONAROD RETWEETED</small>
                                    <div class="borderbox1 d-flex align-items-center flex-wrap">
                                        <h6>John Ramsey</h6>
                                        <span class="text-primary ms-1 d-flex">
                                            <svg width="15" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
                                            </svg>
                                        </span>
                                        <a href="#" class="ms-1">@john_ram</a>
                                        <div class="ms-auto d-flex">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
                                            </svg>
                                            <span class="mx-1"><small>35 mins</small></span>
                                        </div>
                                    </div>
                                        <h6>very good words..</h6>
                                        <div class="border mt-2">
                                    <div class="align-items-center d-flex borderbox1 flex-wrap">
                                            <img src="@/assets/images/user/02.jpg" alt="userimg" class="avatar-20 rounded-circle">
                                            <h6 class="ms-1">theodocre</h6>
                                            <a class="ms-1" href="#">@john_ram</a>
                                            <div class="ms-auto d-flex">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                                                </svg>
                                                <span class="mx-1"><small>35 mins</small></span>
                                            </div>
                                        </div>
                                        <p>In any moment of decsion, the best thing of you can do thing,the next best thing is the wrong thing,and the worst thing of</p>
                                        </div>
                                        <div class="d-flex flex-wrap justify-content-evenly mb-0 mt-2">
                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-primary">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                        </svg><span class="ms-1">32</span></span>
                                        <hr class="hr-vertical">
                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clip-rule="evenodd" />
                                        </svg><span class="ms-1">54</span></span>
                                        <hr class="hr-vertical">
                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                        <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd" />
                                        </svg><span>426</span></span>
                                        <hr class="hr-vertical">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                        </svg>
                                        </div>
                                </div>
                                </div>
                                <div class="borderbox1 mt-2">
                                <div class="user-img me-2">
                                    <img src="@/assets/images/user/1.jpg" alt="userimg" class="avatar-40 rounded-circle">
                                </div>
                                <div class="borderbox border">
                                    <div class="borderbox1 d-flex align-items-center flex-wrap">
                                        <h6>John Ramsey</h6>
                                        <span class="text-primary ms-1">
                                            <svg width="15" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
                                            </svg>
                                        </span>
                                        <a class="ms-1" href="#">@john_ram</a>
                                        <div class="ms-auto d-flex">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                                            </svg>
                                            <span class="mx-1"><small>2 hours</small></span>
                                        </div>
                                    </div>
                                    <h6>Best views from the vactions</h6>
                                    <div class="row mt-2">
                                        <div class="col-lg-4 col-md-6 mt-1">
                                            <img src="@/assets/images/page-img/57.jpg" class="img-fluid rounded" alt="Responsive image">
                                        </div>
                                        <div class="col-lg-4 col-md-6 mt-1">
                                            <img src="@/assets/images/page-img/58.jpg" class="img-fluid rounded" alt="Responsive image">
                                        </div>
                                        <div class="col-lg-4 col-md-6 mt-1">
                                            <img src="@/assets/images/page-img/59.jpg" class="img-fluid rounded" alt="Responsive image">
                                        </div>
                                    </div>
                                    <div class="d-flex flex-wrap justify-content-evenly mb-0 mt-2">
                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-primary">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                        </svg><span class="ms-1">8</span></span>
                                        <hr class="hr-vertical">
                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clip-rule="evenodd" />
                                        </svg><span class="ms-1">12</span></span>
                                        <hr class="hr-vertical">
                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                        <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd" />
                                        </svg><span>47</span></span>
                                        <hr class="hr-vertical">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                        </svg>
                                    </div>
                                </div>
                                </div>
                                <div class="borderbox1 mt-2">
                                    <div class="user-img me-2">
                                    <img src="@/assets/images/user/1.jpg" alt="userimg" class="avatar-40 rounded-circle">
                                </div>
                                    <div class="borderbox border">
                                        <div class="borderbox1 d-flex align-items-center flex-wrap">
                                        <h6>John Ramsey</h6>
                                        <span class="text-primary d-flex ms-1">
                                            <svg width="15" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
                                            </svg>
                                        </span>
                                        <a class="ms-1" href="#">@john_ram</a>
                                        <div class="ms-auto d-flex">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                                            </svg>
                                            <span class="mx-1"><small>2 hours</small></span>
                                        </div>
                                    </div>
                                    <small>Design is intellgence made visible</small>
                                    </div>
                                </div>
                        </div>
                        <div class="tab-pane fade" id="TweetsRetweets" role="tabpanel">
                            <div class="row">
                            <div class="col-sm-12">
                                <div class="">
                                    <div class="card-body">
                                        <div class="d-flex  justify-content-between">
                                            <div class="me-3">
                                            <img src="@/assets/images/icon/09.png" class="img-fluid rounded" alt="Twitter">

                                            </div>
                                            <div class="w-100">
                                                <div class="d-flex justify-content-between">
                                                    <div class="">
                                                    <h5 class="mb-0 d-inline-block me-1"><a href="#" class="">Taha Malaldır</a></h5>
                                                    <p class="mb-0 d-inline-block">Share Anna Mull's Post</p>
                                                    <p class="mb-0">5 hour ago</p>
                                                    </div>
                                                    <div class="card-post-toolbar">
                                                    <div class="dropdown">
                                                        <span class="dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" role="button">
                                                        <i class="ri-more-fill"></i>
                                                        </span>
                                                        <div class="dropdown-menu m-0 p-0">
                                                            <a class="dropdown-item p-3" href="#">
                                                                <div class="d-flex align-items-top">
                                                                <i class="ri-save-line h4"></i>
                                                                <div class="data ms-2">
                                                                    <h6>Save Post</h6>
                                                                    <p class="mb-0">Add this to your saved items</p>
                                                                </div>
                                                                </div>
                                                            </a>
                                                            <a class="dropdown-item p-3" href="#">
                                                                <div class="d-flex align-items-top">
                                                                <i class="ri-pencil-line h4"></i>
                                                                <div class="data ms-2">
                                                                    <h6>Edit Post</h6>
                                                                    <p class="mb-0">Update your post and saved items</p>
                                                                </div>
                                                                </div>
                                                            </a>
                                                            <a class="dropdown-item p-3" href="#">
                                                                <div class="d-flex align-items-top">
                                                                <i class="ri-close-circle-line h4"></i>
                                                                <div class="data ms-2">
                                                                    <h6>Hide From Timeline</h6>
                                                                    <p class="mb-0">See fewer posts like this.</p>
                                                                </div>
                                                                </div>
                                                            </a>
                                                            <a class="dropdown-item p-3" href="#">
                                                                <div class="d-flex align-items-top">
                                                                <i class="ri-delete-bin-7-line h4"></i>
                                                                <div class="data ms-2">
                                                                    <h6>Delete</h6>
                                                                    <p class="mb-0">Remove thids Post on Timeline</p>
                                                                </div>
                                                                </div>
                                                            </a>
                                                            <a class="dropdown-item p-3" href="#">
                                                                <div class="d-flex align-items-top">
                                                                <i class="ri-notification-line h4"></i>
                                                                <div class="data ms-2">
                                                                    <h6>Notifications</h6>
                                                                    <p class="mb-0">Turn on notifications for this post</p>
                                                                </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <span class="mt-1">Forget the pixels for a second. Let’s focus on Tweets.Design Twitter is full of folks who Tweet well, and we want to figure out the secret to their sauce.</span>
                                        <div class="user-post mt-2">
                                            <a href="#"><img src="@/assets/images/page-img/p3.jpg" alt="post-image" class="img-fluid w-100"></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="">
                                        <div class="card-body">
                                            <div class="borderbox border">
                                            <div class="borderbox1 d-flex align-items-center flex-wrap">
                                        <h6>John Ramsey</h6>
                                        <span class="text-primary d-flex ms-1">
                                            <svg width="15" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
                                            </svg>
                                        </span>
                                        <small class="ms-1">@john_ram</small>
                                        <div class="ms-auto d-flex">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 0 20 20" fill="currentColor">
                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
                                            </svg>
                                            <span class="mx-1"><small>2 hours</small></span>
                                        </div>
                                    </div>
                                            <h6>Best views from the vactions</h6>
                                            <div class="row mt-2">
                                                <img src="@/assets/images/page-img/p1.jpg" alt="post-image" class="img-fluid w-100">
                                            </div>
                                            <div class="d-flex flex-wrap justify-content-evenly mb-0 mt-2">
                                                <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="text-primary">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                                                </svg><span class="ms-1">8</span></span>
                                                <hr class="hr-vertical">
                                                <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clip-rule="evenodd"></path>
                                                </svg><span class="ms-1">12</span></span>
                                                <hr class="hr-vertical">
                                                <span><svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                                <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                                </svg><span>47</span></span>
                                                <hr class="hr-vertical">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" viewBox="0 0 20 20" fill="currentColor" class="text-primary">
                                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="Likes" role="tabpanel">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="d-flex justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/09.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">2 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/05.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">2 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>524</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/11.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/02.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>456</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/03.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/05.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/09.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/06.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/08.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>344</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between list-inline mt-1">
                                        <div class="col-lg-6">
                                            <div class="d-flex align-items-center">
                                                <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/07.jpg" alt="">
                                                <div class="media-body ms-1">
                                                    <h6 class="mb-0"><a href="#">Greta Life</a></h6>
                                                    <p class="mb-0">3 hours</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 text-center d-flex">
                                            <span>
                                                <h4>556</h4>
                                            </span>
                                            <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25px" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
                                            </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="Media" role="tabpanel">
                        <div class="mt-2 borderbox1">
                            <div class="user-img me-2">
                                <img src="@/assets/images/user/1.jpg" alt="userimg" class="avatar-40 rounded-circle">
                            </div>
                            <div class="borderbox border">
                                    <h6>very good words..</h6>
                                    <div class="border mt-2">
                                    <p>In any moment of decsion, the best thing of you can do thing,the next best thing is the wrong thing,and the worst thing of</p>
                                    </div>
                                    <h6>Best views from the vactions</h6>
                                <div class="row mt-2">
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/57.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/58.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/59.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2 borderbox1">
                            <div class="user-img me-2">
                                <img src="@/assets/images/user/1.jpg" alt="userimg" class="avatar-40 rounded-circle">
                            </div>
                            <div class="borderbox border">
                                    <h6>very good words..</h6>
                                    <div class="border mt-2">
                                    <p>In any moment of decsion, the best thing of you can do thing,the next best thing is the wrong thing,and the worst thing of</p>
                                    </div>
                                <div class="row mt-2">
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/60.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/61.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/62.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="mt-2 borderbox1">
                            <div class="user-img me-2">
                                <img src="@/assets/images/user/1.jpg" alt="userimg" class="avatar-40 rounded-circle">
                            </div>
                            <div class="borderbox border">
                                    <h6>very good words..</h6>
                                    <div class="border mt-2">
                                    <p>In any moment of decsion, the best thing of you can do thing,the next best thing is the wrong thing,and the worst thing of</p>
                                    </div>
                                <div class="row mt-2">
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/63.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/64.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                    <div class="col-lg-4 col-md-6 mt-1">
                                        <img src="@/assets/images/page-img/65.jpg" class="img-fluid rounded" alt="Responsive image">
                                    </div>
                                </div>
                            </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between">
                            <h6>Trends for you</h6>
                            <i class="ri-settings-4-line"></i>
                        </div>
                    <hr>
                    <li class="d-flex mb-4 align-items-center">
                    <div class="ms-3 flex-grow-1">
                        <h6>#ecommerce</h6>
                        <small>71.4k Tweets</small>
                    </div>
                    <div class="dropdown">
                        <span class="dropdown-toggle" id="dropdownMenuButton9" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                        </span>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton9">
                        <a class="dropdown-item " href="javascript:void(0);">Unfollow</a>
                        <a class="dropdown-item " href="javascript:void(0);">Unfriend</a>
                        <a class="dropdown-item " href="javascript:void(0);">block</a>
                        </div>
                    </div>
                    </li>
                    <li class="d-flex mb-4 align-items-center">
                    <div class="ms-3 flex-grow-1">
                            <h6>#apple</h6>
                            <small>68.2k Tweets</small>
                    </div>
                    <div class="dropdown">
                        <span class="dropdown-toggle" id="dropdownMenuButton9" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                        </span>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton9">
                        <a class="dropdown-item " href="javascript:void(0);">Unfollow</a>
                        <a class="dropdown-item " href="javascript:void(0);">Unfriend</a>
                        <a class="dropdown-item " href="javascript:void(0);">block</a>
                        </div>
                    </div>
                    </li>
                    <li class="d-flex mb-4 align-items-center">
                    <div class="ms-3 flex-grow-1">
                            <h6>#ueta</h6>
                            <small>63.8k Tweets</small>
                    </div>
                    <div class="dropdown">
                        <span class="dropdown-toggle" id="dropdownMenuButton9" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                        </span>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton9">
                        <a class="dropdown-item " href="javascript:void(0);">Unfollow</a>
                        <a class="dropdown-item " href="javascript:void(0);">Unfriend</a>
                        <a class="dropdown-item " href="javascript:void(0);">block</a>
                        </div>
                    </div>
                    </li>
                    <li class="d-flex mb-4 align-items-center">
                    <div class="ms-3 flex-grow-1">
                            <h6>#music</h6>
                            <small>61k Tweets</small>
                    </div>
                    <div class="dropdown">
                        <span class="dropdown-toggle" id="dropdownMenuButton9" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                        </span>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton9">
                        <a class="dropdown-item " href="javascript:void(0);">Unfollow</a>
                        <a class="dropdown-item " href="javascript:void(0);">Unfriend</a>
                        <a class="dropdown-item " href="javascript:void(0);">block</a>
                        </div>
                    </div>
                    </li>
                    <div class="text-center">
                    <small>SEE MORE</small>
                    </div>
                    </div>
                </div>
                <div class="card">
                <div class="card-body">
                <div class="d-flex justify-content-between">
                <h6>You should follow</h6>
                <i class="ri-settings-4-line"></i>
                </div>
                <hr>
                <ul class="list-inline m-0 p-0">
                    <li class="d-flex mb-4 align-items-center">
                        <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/01.jpg" alt="">
                        <div class="ms-1 flex-grow-1">
                            <h6>Kate Lingrad</h6>
                            <small>@kate14</small>
                        </div>
                        <button type="submit" class="btn bg-soft-primary smallbutton">follow</button>
                    </li>
                    <li class="d-flex mb-4 align-items-center">
                        <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/02.jpg" alt="">
                        <div class="ms-1 flex-grow-1">
                            <h6>Snowman</h6>
                            <small>@snow_man</small>
                        </div>
                        <button type="submit" class="btn bg-soft-primary smallbutton">follow</button>
                    </li>
                    <li class="d-flex mb-4 align-items-center">
                        <img class="img-fluid rounded-circle avatar-40" src="@/assets/images/user/03.jpg" alt="">
                        <div class="ms-1 flex-grow-1">
                            <h6>Sharapova</h6>
                            <small>@Sharapova</small>
                        </div>
                        <button type="submit" class="btn bg-soft-primary smallbutton">follow</button>
                    </li>
                </ul>
                <div class="text-center mt-2">
                <small>SEE ALL</small>
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Profile1'
}
</script>
